import React, { useState } from "react";
import PageBreadcrumb from "../../components/common/CustomBreadCrumb";
import ComponentCard from "../../components/common/ComponentCard";
import HistoryTable from "../../components/tables/HistoryTable";
import PageMeta from "../../components/common/PageMeta";
import Input from "../../components/form/input/InputField";
import { Search } from "lucide-react";
import { useSearchParams } from "react-router";
import { useHistory } from '@/hooks/useHistory';
import { useTranslation } from "react-i18next";

export default function ListHistoryByDeck() {
    const [searchParams] = useSearchParams();
    const deckId = searchParams.get("deckId") || "";
    const quizId = searchParams.get("quizId") || "";
    const { t } = useTranslation();

    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");

    const { data, isLoading, isError } = useHistory(currentPage, searchQuery, deckId, quizId);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <>
            <PageMeta
                title={t("VIYUME - VIYUME Dashboard")}
                description={t("USER_MANAGEMENT")}
            />
            <div className="space-y-6">
                <ComponentCard title="">
                    {isLoading ? (
                        <div className="animate-pulse">
                            <div className="space-y-4">
                                {[...Array(5)].map((_, index) => (
                                    <div key={index} className="flex items-center space-x-4 py-3">
                                        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                        <div className="h-4 bg-gray-200 rounded w-1/6"></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : isError ? (
                        <div className="text-red-500 text-center p-4">Failed to fetch history.</div>
                    ) : (
                        <HistoryTable
                            histories={data?.histories || []}
                            currentPage={currentPage}
                            totalPages={Math.ceil((data?.count || 0) / 10)}
                            onPageChange={handlePageChange}
                        />
                    )}
                </ComponentCard>
            </div>
        </>
    );
}
